// This file is auto-generated by generate-version.js during build
// Do not edit manually - changes will be overwritten
export const versionInfo = {
  version: '1.2.0'
};
